<template>
  <!--====== Section 2: 문제 제기 - 기존 외주의 한계 ======-->
  <section class="appie-services-2-area appie-services-8-area pt-90 pb-55" id="service-details">
    <div class="container">
      <div class="row align-items-end">
        <div class="col-lg-12">
          <div class="appie-section-title text-center">
            <h3 class="appie-title">외주 개발, 왜 늘 비슷한 문제가 반복될까요?</h3>
            <p>문제는 사람이 아니라, 비효율적인 개발 방식입니다.</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-3 col-md-6">
          <div class="appie-single-service-2 appie-single-service-about mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="200ms">
            <div class="icon">
              <i class="fal fa-exchange-alt"></i>
            </div>
            <h4 class="title">요구사항 왜곡</h4>
            <p>기획 전달 과정에서 요구사항이 왜곡되어 원하는 결과물이 나오지 않습니다.</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="appie-single-service-2 appie-single-service-about item-2 mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="400ms">
            <div class="icon">
              <i class="fal fa-coins"></i>
            </div>
            <h4 class="title">수정 비용 증가</h4>
            <p>수정할 때마다 비용과 일정을 재협의해야 하는 부담이 있습니다.</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="appie-single-service-2 appie-single-service-about item-3 mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="600ms">
            <div class="icon">
              <i class="fal fa-users"></i>
            </div>
            <h4 class="title">속도 한계</h4>
            <p>개발 속도가 투입 인력 수에만 의존하여 확장이 어렵습니다.</p>
          </div>
        </div>
        <div class="col-lg-3 col-md-6">
          <div class="appie-single-service-2 appie-single-service-about item-4 mt-30 wow animated fadeInUp" data-wow-duration="2000ms" data-wow-delay="800ms">
            <div class="icon">
              <i class="fal fa-eye-slash"></i>
            </div>
            <h4 class="title">늦은 결과 확인</h4>
            <p>결과물은 프로젝트 마지막에 가서야 확인할 수 있습니다.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {

}
</script>

<style>

</style>
